import { render, staticRenderFns } from "./CaseEnter.vue?vue&type=template&id=2ec78651&scoped=true&"
import script from "./CaseEnter.vue?vue&type=script&lang=js&"
export * from "./CaseEnter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec78651",
  null
  
)

export default component.exports